import "./NavbarStyles.css";

import React, { useState } from 'react';
import { Link } from "react-scroll";

import { FaBars, FaTimes } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import Logo from "../assets/oseelight-logo.jpg"


const languages = [
    {value:'en' ,text:"EN"},
    {value:'zh' ,text:"中文"},
]; 

const Navbar = () => {

    const [click, setClick] = useState(false);
    const handleClick = () => setClick(!click);

    const closeMenu = () => setClick(false);

    const [color, setColor] = useState(false);
    const changeColor = () =>{
        if(window.scrollY >=100){
            setColor(true);
        }else{
            setColor(false);
        }
    };
    window.addEventListener("scroll",changeColor);

    const { t,i18n} = useTranslation();
    const [lang] = useState('en');
    const onChangeLanguage = (e) => {
        console.log(e);
        i18n.changeLanguage(e.target.value);
           };

  return (
   
    <div className={color ? "header header-bg" : "header"}>
        <Link to="/">
            <div className="nav-left">
                <img className="logo-img" src={Logo} alt="logoimage"></img>
                <h2>IT Consulting</h2>
            </div>
        </Link>
        <ul className={click ? "nav-menu active" : "nav-menu"} >
            <li>
                <Link to="home-section" smooth={true} offset={-500} duration={-90} onClick={closeMenu}>{t('home')}</Link>
            </li>
            <li >
                <Link to="about-section" spy={true} smooth={true} offset={-90} duration={500} onClick={closeMenu}>{t('about.title')}</Link> 
            </li>
            <li>
                <Link to="service-section" spy={true} smooth={true} offset={-90} duration={500} onClick={closeMenu}>{t('services.title')}</Link>
            </li>
            <li>
                <Link to="contact-section" spy={true} smooth={true} offset={-90} duration={500} onClick={closeMenu}>{t('contact.title')}</Link>
            </li>
            <li>
                <Link to="customer-section" spy={true} smooth={true} offset={-90} duration={500} onClick={closeMenu}>{t('customers')}</Link>
            </li>
            <li className="sel-language">
                <select  defaultValue={lang} onChange= {onChangeLanguage} >
                         { languages.map(item => {
                            return (<option key={item.value} value={item.value}>{item.text}</option>)
                        }) }
                </select>
            </li>            
        </ul>
        <div className="hamburger" onClick={handleClick}>
            {click ? (
                <FaTimes size={20} style={ {color:"#fff" } } />
            ):(
                <FaBars size={20} style={ {color:"#fff" } } />
              
            )}

        </div>
    </div>
  );
};

export default Navbar